import { render, staticRenderFns } from "./powerbi.vue?vue&type=template&id=6cf6f732&scoped=true"
import script from "./powerbi.vue?vue&type=script&lang=js"
export * from "./powerbi.vue?vue&type=script&lang=js"
import style0 from "./powerbi.vue?vue&type=style&index=0&id=6cf6f732&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6f732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf6f732')) {
      api.createRecord('6cf6f732', component.options)
    } else {
      api.reload('6cf6f732', component.options)
    }
    module.hot.accept("./powerbi.vue?vue&type=template&id=6cf6f732&scoped=true", function () {
      api.rerender('6cf6f732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/powerbi.vue"
export default component.exports